
import { store } from '../store/store';

/**
 * Update a work/book via the API
 * @param {string} API_BASE 
 * @param {string} token 
 * @param {object} workData The full nested work object structure
 * @returns {Promise<object>} The updated work object
 */
async function updateWork(API_BASE, token, workData) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    //console.log("Updating work with payload:", workData);

    const response = await fetch(`${API_BASE}/works/${workData.ID}`, {
        method: "PUT",
        headers,
        body: JSON.stringify(workData),
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la mise à jour du livre: " + (await response.text()));
    }

    const updatedWork = await response.json();
    return updatedWork;
}

export default updateWork;
